import { TopNavVisibility } from '../providers/TopNavProvider';

export type ClassesToApplyType = {
  padding: string;
  height: string;
  vheight: string;
  top: string;
};

export const topNavOffsetClassesGetter = (
  visibility: TopNavVisibility,
  workspacesNumber: number
): ClassesToApplyType => {
  const { top: first, second, third } = visibility;
  let padding = '';
  let height = '';
  let vheight = '';
  let top = '';
  if (first && !second && !third) {
    padding = 'TopNavPadding';
    height = 'TopNavHeightOffset';
    vheight = 'TopNavVHeightOffset';
    top = 'TopNavOffset';
  }
  if (first && second && !third) {
    if (workspacesNumber < 2) {
      padding = 'TopSecondNavPadding SingleWorkspace';
      height = 'TopSecondNavHeightOffset SingleWorkspace';
      vheight = 'TopSecondNavVHeightOffset SingleWorkspace';
      top = 'TopSecondNavOffset SingleWorkspace';
    } else {
      padding = 'TopSecondNavPadding MultipleWorkspaces';
      height = 'TopSecondNavHeightOffset MultipleWorkspaces';
      vheight = 'TopSecondNavVHeightOffset MultipleWorkspaces';
      top = 'TopSecondNavOffset MultipleWorkspaces';
    }
  }
  if (first && second && third) {
    if (workspacesNumber < 2) {
      padding = 'TopSecondThirdNavPadding SingleWorkspace';
      height = 'TopSecondThirdNavHeightOffset SingleWorkspace';
      vheight = 'TopSecondThirdNavVHeightOffset SingleWorkspace';
      top = 'TopSecondThirdNavOffset SingleWorkspace';
    } else {
      padding = 'TopSecondThirdNavPadding MultipleWorkspaces';
      height = 'TopSecondThirdNavHeightOffset MultipleWorkspaces';
      vheight = 'TopSecondThirdNavVHeightOffset MultipleWorkspaces';
      top = 'TopSecondThirdNavOffset MultipleWorkspaces';
    }
  }
  if (first && !second && third) {
    padding = 'TopThirdNavPadding';
    height = 'TopThirdNavHeightOffset';
    vheight = 'TopThirdNavVHeightOffset';
    top = 'TopThirdNavOffset';
  }
  return {
    padding,
    top,
    height,
    vheight
  };
};
